import clsx from "clsx";
import { HTMLInputTypeAttribute, InputHTMLAttributes } from "react";

interface Props extends InputHTMLAttributes<HTMLInputElement>{
  id?: string;
  name?: string;
  placeholder?: string;
  Icon?: any;
  type?: HTMLInputTypeAttribute;
  step?: string;
  required?: boolean;
  defaultValue?:any;
  className?:string;
};
export default function ({ id, name, placeholder, Icon, type, step, required, defaultValue,className,...rest }: Props) {
  return (
    <div className="relative w-full">
      <input
        {...rest}
        id={id}
        name={name}
        type={type}
        step={step}
        placeholder={placeholder}
        required={required}
        defaultValue={defaultValue}
        className={clsx(
          "peer block w-full rounded-md border border-gray-200 py-2 pl-10 text-sm outline-2 placeholder:text-gray-500",
          {
            "pl-10": Icon != null,
            "pl-2": Icon == null,
          },className
        )}
      />
      {Icon ? (
        <Icon className="pointer-events-none absolute left-3 top-1/2 h-[18px] w-[18px] -translate-y-1/2 text-gray-500 peer-focus:text-gray-900" />
      ) : null}
    </div>
  );
}
